module.exports = __webpack_public_path__ + "img/fearless-logo.89b57481.jpg";